import React from "react";
import styled from "styled-components";
import { THEME_COLORS } from "../../../ThemeConfig";
import warning from "../../../assets/icons/alert-blue.svg";

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    background: white;
    padding: 30px;
    border-radius: 12px;
    max-width: 400px;
    width: 90%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`;

const WarningIcon = styled.img`
    width: 48px;
    height: 48px;
    margin-bottom: 10px;
`;

const ModalTitle = styled.h3`
    color: ${THEME_COLORS.primary};
    font-size: 20px;
    margin: 0;
    font-weight: 600;
`;

const ModalMessage = styled.p`
    color: ${THEME_COLORS.text};
    font-size: 16px;
    margin: 0;
    line-height: 1.5;
`;

const OkButton = styled.button`
    background: ${THEME_COLORS.primary};
    color: white;
    border: none;
    padding: 12px 40px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
        background: ${THEME_COLORS.primaryDark};
    }
`;

function ErrorModal({ isOpen, onClose, title, message }) {
    if (!isOpen) return null;

    return (
        <ModalOverlay>
            <ModalContent>
                <WarningIcon src={warning} alt="warning" />
                <ModalTitle>{title}</ModalTitle>
                <ModalMessage>{message}</ModalMessage>
                <OkButton onClick={onClose}>OK</OkButton>
            </ModalContent>
        </ModalOverlay>
    );
}

export default ErrorModal;